import { C } from "../../theme/tokens";

/* Copytrading's own card silhouette: a ticket stub with punched
   notches on the left/right edges (like a movie ticket), in the
   section's emerald accent — distinct from Profile/Signals' single
   corner-cut TicketCard and Scanner's viewfinder-bracket cut. */
export function CopyTicketCard({ children }) {
  return (
    <div
      style={{
        position: "relative",
        background: `linear-gradient(160deg, ${C.panel2}, ${C.panel1} 60%)`,
        border: `1px solid ${C.copy}66`,
        borderRadius: 20,
        padding: "26px 22px 22px",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          height: 3,
          borderRadius: "20px 20px 0 0",
          background: `linear-gradient(90deg, transparent, ${C.copyBright}, transparent)`,
        }}
      />
      <Notch side="left" />
      <Notch side="right" />
      {children}
    </div>
  );
}

function Notch({ side }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        [side]: -9,
        transform: "translateY(-50%)",
        width: 18,
        height: 18,
        borderRadius: "50%",
        background: C.canvas,
        border: `1px solid ${C.copy}66`,
      }}
    />
  );
}
